import { render, staticRenderFns } from "./ResolutionsTunnel.vue?vue&type=template&id=8f1879f0&"
import script from "./ResolutionsTunnel.vue?vue&type=script&lang=js&"
export * from "./ResolutionsTunnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports